export default {
  apiKey: 'AIzaSyDO2cRLcCr30m9-EMO6QbUhmtt8AC6ahCU',
  authDomain: 'recipes-1b84b.firebaseapp.com',
  databaseURL: 'https://recipes-1b84b.firebaseio.com',
  projectId: 'recipes-1b84b',
  storageBucket: 'recipes-1b84b.appspot.com',
  messagingSenderId: '1000395519382'
}
